import { render, staticRenderFns } from "./AddressSplitter.vue?vue&type=template&id=a70c8572&scoped=true&"
import script from "./AddressSplitter.vue?vue&type=script&lang=js&"
export * from "./AddressSplitter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a70c8572",
  null
  
)

export default component.exports